const STORAGE_KEY = 'bildit_roi_signup_utm';

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
];

const MAX_LEN = 500;

/**
 * Reads UTM query params, merges with values already stored for this tab, and
 * persists so attribution survives SPA navigation before submit.
 */
export function captureSignupUtmFromUrl() {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  const fromUrl = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value?.trim()) {
      fromUrl[key] = value.trim().slice(0, MAX_LEN);
    }
  }

  let stored = {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    stored = raw ? JSON.parse(raw) : {};
    if (
      typeof stored !== 'object' ||
      stored === null ||
      Array.isArray(stored)
    ) {
      stored = {};
    }
  } catch {
    stored = {};
  }

  const merged =
    Object.keys(fromUrl).length > 0 ? { ...stored, ...fromUrl } : stored;

  if (Object.keys(merged).length > 0) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch {
      // quota / private mode
    }
  }

  return merged;
}

export function getStoredUtm() {
  if (typeof window === 'undefined') {
    return {};
  }
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    if (
      typeof parsed !== 'object' ||
      parsed === null ||
      Array.isArray(parsed)
    ) {
      return {};
    }
    const out = {};
    for (const key of UTM_KEYS) {
      const v = parsed[key];
      if (v != null && String(v).trim()) {
        out[key] = String(v).trim().slice(0, MAX_LEN);
      }
    }
    return out;
  } catch {
    return {};
  }
}

/** Merge stored UTM fields into a gtag event payload (GA4 custom dimensions). */
export function withSignupUtm(eventParams) {
  const utm = getStoredUtm();
  if (Object.keys(utm).length === 0) {
    return { ...eventParams };
  }
  return {
    ...eventParams,
    ...utm,
    signup_utm_attributed: true,
  };
}
